import React from 'react';
import {useNavigate} from "react-router-dom";
import {IoSearchCircleOutline} from "react-icons/io5";
import {HiOutlineLocationMarker} from "react-icons/hi";
import {PiShoppingCartFill} from "react-icons/pi";
import { useCart } from '../../../context/CartContext';
import {showWarning} from "../../../utils/toastHelper";

const SearchBar = () => {
    const navigate = useNavigate();
    const config = window.APP_CONFIG;
    const { cart } = useCart();

    
    return (
    <section className="container mt-md-3  py-3 rtl px-2 searchbar">
        <div className="row search-city mx-2  ">

            <div className="col-12 border rounded bg-white py-1 px-0"

            >
                <IoSearchCircleOutline className='text-secondary text-big-3 me-1'
                                       onClick={
                                           () => {
                                               navigate(`/search`);
                                           }
                                       }
                />
                <span className='text-secondary text-small-3 pe-3 '>
                        <span
                            onClick={
                                () => {
                                    navigate(`/search`);
                                }
                            }
                        >جستجو در
                            &nbsp;
                            {config.title}</span>

                    {config.service_app_settings.show_city_selcet > 0 ?
                        <span className='text-small-1  bg-secondary-subtle py-1 px-3 rounded float-start ms-1' onClick={
                            () => {
                                navigate('/select-city')
                            }
                        }>
                 <HiOutlineLocationMarker className='ms-2'/>

                 <strong>
                     مشهد
                 </strong>
             </span>
                        :
                        <img src={config.logo_square} alt={config.title} className="mx-2 float-start" width='25'/>
                    }


                        </span>
            </div>




        </div>
    </section>
    );
};

export default SearchBar;